import type { LightingProfile } from './lighting-profile';

/** Deterministic cache invalidation, not an authentication/content-integrity hash. */
export function probeKey(value: unknown): string {
  const canonical = (v: unknown): unknown => Array.isArray(v)?v.map(canonical):v&&typeof v==='object'?Object.fromEntries(Object.entries(v).sort(([a],[b])=>a.localeCompare(b)).map(([k,x])=>[k,canonical(x)])):v;
  const bytes=new TextEncoder().encode(JSON.stringify(canonical(value)));let hash=2166136261;
  for(const byte of bytes) hash=Math.imul(hash^byte,16777619);
  return (hash>>>0).toString(16).padStart(8,'0');
}
export function probeLightingKey(profile: LightingProfile): string {
  const {sky,sun,ambient,emissiveScale,lights}=profile;
  return probeKey({captureVersion:2,sky,sun,ambient,emissiveScale,lights,probes:profile.probes?.map(({id,position})=>({id,position}))??[]});
}
